// extracted by mini-css-extract-plugin
export var ctaAlignLeft = "IconBtn-module--cta-align-left--aKeAa";
export var ctaAlignRight = "IconBtn-module--cta-align-right--1YcAn";
export var variantPlayButton = "IconBtn-module--variant-play-button--1XM79";
export var slideControl = "IconBtn-module--slide-control--3PZOI";
export var variantEmail = "IconBtn-module--variant-email--YLD6R";